export default "__VITE_ASSET__CDJzBXF9__"